import "./siteHeader.css";

import React from "react";
import { useNavigate } from "react-router-dom";
import { useVBTranslation } from "./language";

const PUBLIC_NAV_ITEMS = [
  { key: "navHome", path: "/" },
  { key: "navCabBooking", path: "/cab-booking" },
  { key: "navHomeServices", path: "/services/home-services" },
  { key: "navProvider", path: "/home/provider-services" }
];

const SiteHeader = ({ search, children }) => {
  const navigate = useNavigate();
  const { t, language, setLanguage, options } = useVBTranslation();
  const isLoggedIn = Boolean(sessionStorage.getItem("token"));
  const activeRole = sessionStorage.getItem("vbActiveRole") || "consumer";
  const user = JSON.parse(sessionStorage.getItem("vbUser") || "{}");
  const hasProviderAccess = Boolean(user?.providerId || user?.isProvider || user?.providerRegistered);
  const showRoleViewTabs = false;
  const dashboardPath = activeRole === "provider" ? "/provider-dashboard" : "/consumer-dashboard";

  const loggedInNavItems = [
    ...(showRoleViewTabs && hasProviderAccess
      ? [
          { label: "Consumer View", path: "/consumer-dashboard" },
          { label: "Provider View", path: "/provider-dashboard" }
        ]
      : []),
  ];

  const navItems = isLoggedIn ? loggedInNavItems : PUBLIC_NAV_ITEMS;

  const openBrandHome = () => {
    navigate(isLoggedIn ? dashboardPath : "/");
  };

  return (
    <header className="vsh-header">
      <div className="vsh-header-inner">
        <button type="button" className="vsh-brand" onClick={openBrandHome}>
          <span />
          <div>
            <strong>
              <em>Vyntez</em>
              <i>Buddy</i>
            </strong>
            <small>Services at your doorstep</small>
          </div>
        </button>

        <nav className="vsh-nav" aria-label="Primary">
          {navItems.map((item) => (
            <button
              key={item.key || item.label}
              type="button"
              className="vsh-nav-link"
              onClick={() => {
                if (item.key === "navProvider" && !isLoggedIn) {
                  navigate("/login?next=/home/provider-services");
                  return;
                }
                navigate(item.path);
              }}
            >
              {item.label || t(item.key)}
            </button>
          ))}
        </nav>

        <div className="vsh-tools">
          {search && (
            <label className="vsh-search-pill" aria-label={t("navSearchPlaceholder")}>
              <i className="fas fa-search" aria-hidden="true"></i>
              <input
                type="search"
                value={search.value}
                onChange={(event) => search.onChange(event.target.value)}
                placeholder={t("navSearchPlaceholder")}
              />
            </label>
          )}

          <select
            value={language}
            onChange={(event) => setLanguage(event.target.value)}
            className="vsh-language-select"
            aria-label={t("navLanguage")}
          >
            {options.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>

          {children}

          {!children && (
            <button
              type="button"
              className="vsh-login-pill-btn"
              onClick={() => navigate(isLoggedIn ? dashboardPath : "/login")}
            >
              {isLoggedIn ? t("navDashboard") : t("navLogin")}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
